import { translations } from '../translations';
import type { TranslationKeys } from '../translations/index.d';

const translationKeysSet = new Set<string>(
    Object.keys(translations.en)
);

export const hasTranslation = (id: string): id is TranslationKeys => {
    return translationKeysSet.has(id);
};